var metaCustomJs = document.querySelector('meta[name="custom-js"]');
let isCard       = false;

if (metaCustomJs != null) {
  if (metaCustomJs.getAttribute('custom-js') == 'true') {
    isCard = true;
  }
}

await import(`${isCard ? `https://ga.jspm.io/npm:card-js@1.0.13/card-js.min.js` : `card-js`}`)

$(document).ready(function() {
  // init checkbox START
  // Mendapatkan elemen-elemen yang diperlukan
  var unitRadios               = document.querySelectorAll('input[name="unit-list"]');
  var newUnitAddressPanel      = document.getElementById('new-unit-address-panel');
  var existingUnitAddressPanel = document.getElementById('existing-unit-address-panel');

  // Menyembunyikan panel-unit yang ada pada awalnya
  if (newUnitAddressPanel != null) {
    newUnitAddressPanel.style.display = 'none';
  }

  if (existingUnitAddressPanel != null) {
    existingUnitAddressPanel.style.display = 'none';
  }

  // Menambahkan event listener untuk radio button
  if (unitRadios != null) {
    unitRadios.forEach(function(radio) {
      radio.addEventListener('change', function() {
        if (radio.value === 'new') {
          var popup = document.getElementById("add-unit-address");

          popup.classList.add('show')
          newUnitAddressPanel.style.display = 'block';
          existingUnitAddressPanel.style.display = 'none';
        } else if (radio.value === 'existing') {
          var popup = document.getElementById("existing-unit-address");

          popup.classList.add('show')
          newUnitAddressPanel.style.display = 'none';
          existingUnitAddressPanel.style.display = 'block';
        }
      });
    });
  }
  // init checkbox END

  var unitAddress = '';

  var sectionunitAddress = document.getElementById("section-unit-address-filled");
  if (sectionunitAddress != null) {
    sectionunitAddress.style.display = "none";
  }

  var setMyUnitButton = document.getElementById("set-my-unit");
  if (setUnitButton != null) {
    if (setMyUnitButton) {
      setMyUnitButton.addEventListener("click", function() {
        var popup = document.getElementById("existing-unit-address");
        popup.classList.remove('show');
      });
    }
  }

  var setUnitButton = document.getElementById("set-unit");
  if (setUnitButton != null) {
    if (setUnitButton) {
      setUnitButton.addEventListener("click", function() {
        var addressInput = document.getElementById("data-unit-address");
        var address = addressInput.value;

        var countrySelect = document.getElementById("data-unit-country-select");
        var country = countrySelect.options[countrySelect.selectedIndex].text;

        var stateSelect = document.getElementById("data-unit-state-select");
        var state = stateSelect.options[stateSelect.selectedIndex].text;

        var citySelect = document.getElementById("data-unit-city-select");
        var city = citySelect.options[citySelect.selectedIndex].text;

        var postcodeInput = document.getElementById("data-unit-postcode");
        var postcode = postcodeInput.value;

        var unitLabel = document.getElementById("data-unit-label");
        var unitLabel = unitLabel.value;

        unitAddress = `${address},${country}, ${state}, ${city}, ${postcode}`;

        var sectionunitAddress = document.getElementById("section-unit-address-none");
        sectionunitAddress.style.display = "none";
        var sectionunitAddress = document.getElementById("section-unit-address-filled");
        sectionunitAddress.style.display = "block";

        var unitAddressResultElement = document.getElementById("unit-address-result");
        unitAddressResultElement.textContent = unitAddress;

        var unitAddressLabel = document.getElementById("unit-address-label");
        unitAddressLabel.textContent = unitLabel;

        var popup = document.getElementById("add-unit-address");
        popup.classList.remove('show')
      });
    }
  }

  // submit form button pay now
  var buttonPayNow = document.querySelector('#submit-button-pay-now');
  if (buttonPayNow != null) {
    buttonPayNow.addEventListener('click', function() {
      var form = buttonPayNow.closest('form');

      // validate payment method
      var payment_method = document.querySelector('input[name = "payment_method"]:checked');
      if (payment_method == null) {
        alert("Payment method can't be blank!");
        return false;
      } else {
        if (payment_method.value == 'Moneris') {
          if (!validateCreditNumber()) {
            alert("Please input credit number!");
            return false;
          }
        }
      }

      var select_address = document.querySelector('input[name = "address_id"]:checked');
      // if (select_address == null) {
      //   alert("Address can't be blank!");
      //   return false;
      // }

      // validate send as gift
      var arrGiftValidation = [];
      $.each($('.switch-send-as-gift:checked'), function(key, element) {
        var id             = $(element).data('id');
        var recipientEmail = $(`#formRecipientEmail-${id}`).val();
        var regexEmail     = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

        if (!regexEmail.test(recipientEmail)) {
          alert("Recipient Mail can't be blank or invalid format!");
          arrGiftValidation.push(true)
        }

        var recipientName = $(`#formRecipientName-${id}`);
        if ($.trim(recipientName.val()).length <= 0) {
          alert("Recipient Name can't be blank!");
          arrGiftValidation.push(true)
        }
      })

      if (arrGiftValidation.includes(true)) {
        return false;
      }

      form.submit()
    })
  }

  // submit form cancel shadow order
  var buttonCancel = document.querySelector('#button-cancel-shadow-order');
  if (buttonCancel != null) {
    buttonCancel.addEventListener('click', function(e) {

      // validate payment method
      var reason = document.querySelector('input[name = "choose-reason"]:checked');
      if (reason == null) {
        alert("Please choose reason!");
        e.preventDefault();
        e.stopPropagation();
      }
    })
  }
});

function validateCreditNumber() {
  var myCard      = $('#my-card');
  var cardNumber  = myCard.CardJs('cardNumber');
  var cardName    = myCard.CardJs('name');
  var expiryMonth = myCard.CardJs('expiryMonth');
  var expiryYear  = myCard.CardJs('expiryYear');
  var cvc         = myCard.CardJs('cvc');

  if ((cardNumber.length >= 1) && (expiryMonth.length >= 1) && (expiryYear.length >= 1) && (cvc.length >= 1)) {
    var creditCardInput = `<input type='hidden' name='credit_number[card_number]' value='${cardNumber}'>`+
                          `<input type='hidden' name='credit_number[expiry_month]' value='${expiryMonth}'>`+
                          `<input type='hidden' name='credit_number[expiry_year]' value='${expiryYear}'>`+
                          `<input type='hidden' name='credit_number[card_name]' value='${cardName}'>`+
                          `<input type='hidden' name='credit_number[cvc]' value='${cvc}'>`;
    document.querySelector('#input-credit-card').innerHTML = creditCardInput
    return true;
  } else {
    return false;
  }
}